/**
 * Route for `reddit-conversions-api`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RedditConversionsApiPage } from "../features/reddit-conversions-api/RedditConversionsApiPage";

export const redditConversionsApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/reddit-conversions-api",
	component: RedditConversionsApiPage,
});

export default redditConversionsApiRoute;
